import { Box, ChakraProvider } from '@chakra-ui/react';
import { ReactLenis } from 'lenis/react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import './App.css';
import ErrorBoundary from './components/errorBoundary';
import chakraTheme from './lib/chakra/theme';
import CursorFollowerProvider from './providers/cursorProvider';
import TiltProvider from './providers/tilt';
import AppRouter from './routes/appRouter';

const queryClient = new QueryClient();

function App() {
  return (
    <ErrorBoundary>
      <RecoilRoot>
        <HelmetProvider>
          <BrowserRouter>
            <QueryClientProvider client={queryClient}>
              <ChakraProvider theme={chakraTheme}>
                <Box w={'100vw'} overflowX={'hidden'} minH={'100vh'}>
                  <CursorFollowerProvider />
                  <ReactLenis root options={{ autoRaf: true }}>
                    <AppRouter />
                  </ReactLenis>
                  <Toaster
                    position="top-center"
                    containerStyle={{
                      top: '60px',
                    }}
                    toastOptions={{
                      style: {
                        fontSize: '16px',
                        border: '1px solid #E7E8EB',
                        borderRadius: '8px',
                        textAlign: 'center',
                        fontWeight: 500,
                        overflow: 'hidden',
                        background: '#0F172A',
                        color: '#fff',
                        paddingInline: '20px',
                      },
                    }}
                  />
                  <TiltProvider />
                </Box>
              </ChakraProvider>
            </QueryClientProvider>
          </BrowserRouter>
        </HelmetProvider>
      </RecoilRoot>
    </ErrorBoundary>
  );
}

export default App;
